import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { PushPrompt } from "@/components/pwa/InstallButton";
import { openNotification } from "@/components/layout/NotificationBell";
import { useNotifications } from "@/context/NotificationsContext";
import { fmtDateTime } from "@/lib/format";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";
import { TrashButton, deleteNotification, useLongPress } from "@/components/work/SuperDelete";

const Row = ({ n, onOpen, canDelete, onDeleted }) => {
  const del = canDelete ? async () => { if (await deleteNotification(n)) onDeleted(); } : null;
  const press = useLongPress(del);
  return (
    <div className={cn("flex items-start border-t border-slate-100", !n.read && "bg-teal-50/40")} {...press}>
      <button type="button" onClick={onOpen} data-testid={`notifications-item-${n.id}`} className="block min-w-0 flex-1 px-4 py-3 text-left">
        <div className="flex items-start gap-2">
          {!n.read && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-teal-600" />}
          <div className="min-w-0">
            <div className="truncate text-sm font-medium text-slate-900">{n.title}</div>
            <div className="line-clamp-2 text-sm text-slate-600">{n.text}</div>
            <div className="mt-1 text-xs text-slate-400">{fmtDateTime(n.created_at)}</div>
          </div>
        </div>
      </button>
      {del && <TrashButton onClick={del} testid={`notification-delete-${n.id}`} />}
    </div>
  );
};

export default function NotificationsPage() {
  const { items, unread, markRead, markAll, reload } = useNotifications();
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="space-y-5" data-testid="notifications-page">
      <PageHeader eyebrow="Work" title="Notifications"
        actions={unread > 0 && <button type="button" onClick={markAll} className="min-h-[44px] text-sm font-medium text-teal-700" data-testid="notifications-mark-all">Mark all read</button>} />
      <div className="overflow-hidden rounded-lg border border-slate-200 bg-white">
        <PushPrompt />
        {items.length === 0 && <p className="px-4 py-10 text-center text-sm text-slate-500" data-testid="notifications-empty">No notifications yet</p>}
        {items.map((n) => <Row key={n.id} n={n} onOpen={() => { markRead(n); openNotification(n, navigate); }} canDelete={user?.is_super_admin} onDeleted={reload} />)}
      </div>
    </div>
  );
}
